module.exports = __webpack_public_path__ + "img/e-smartship.93fbe9b3.png";